import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import {t} from 'i18next';
import CriteriaCalendarComponent from '../components/criteria/CriteriaCalendarComponent';
import NumberUtils from '../utils/NumberUtils';
import {PrintButtonComponent} from '../report/ReportUtils';
import {Chip} from 'primereact/chip';
import {ColumnGroup} from 'primereact/columngroup';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import { withRouter } from "react-router-dom";
import PayrollEntryService from '../services/PayrollEntryService';

class PayrollEntryListContainer extends BaseListContainer {
    constructor(props) {
        
        super(props, new PayrollEntryService());
        this.state = {
            list: [],
            loading: true,
            contractTypes: [],
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
        };
    }

    updateSearchCriteria(criteria) {
        return {
            fullName: criteria.fullName,
            contractType: criteria.contractType,
            date: criteria.date,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        return {
            fullName: null,
            contractType: null,
            date: date,
            firstResult: 0,
            maxResults: 10,
            sortAsc: false,
            sortField: 'id',
        };
    }

    getCriteriaName() {
        return 'payrollEntry-list-sc';
    }

    getContainerListName() {
        return 'payrollEntry-list-container';
    }
    getListTitle() {
        return 'payrollEntry.listName';
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('UserContractType')
            .then((contractTypes) => this.setState({contractTypes}))
            .catch(() => {
                this.showErrorMessage(t('global.contractTypesErrorMessage'));
            });
    }

    footerGroup() {
        return <ColumnGroup></ColumnGroup>;
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='fullName-sc'
                    name='fullName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.fullName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('global.user')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaDropdownComponent
                    id='contractType-sc'
                    name='contractType'
                    showClear
                    label={t('global.contractType')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.contractType}
                    options={this.state.contractTypes}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='enumValue'
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />

                <CriteriaCalendarComponent
                    label={t('global.month')}
                    id='dateSc'
                    name='date'
                    showIcon
                    colClass='col-lg-3'
                    viewMode='EDIT'
                    value={this.state.criteria.date}
                    onChange={(a, b, e, d, f, g, h) => {
                        if (e.value === null) {
                            e.value = '';
                            e.target.value = '';
                        }
                        this.handleChangeSc(a, b, e, d, f, g, h);
                    }}
                    refreshFromBackend
                    view='month'
                    placeholder='mm-yy'
                    dateFormat='mm-yy'
                    validator={this.validator}
                    timeoutHandler={this.refreshTable}
                />
            </div>
        );
    }

    prepareColumns() {
        return [
            {
                field: 'user.fullName',
                header: t('global.user'),
            },
            {
                field: 'user.contractType',
                header: t('global.contractType'),
            },

            {
                field: 'time',
                header: 'Godziny/Godziny zatwierdzone',
                body: (rowData) => this.formatTimeAppovedAndTotal(rowData),
                width: '222px',
                style: {
                    width: '20px',
                },
                align: 'right',
            },
            {
                field: 'percentageOfCreativeTime',
                header: t('payrollEntry.percentageOfCreativeTime'),
                body: (rowData) => rowData.percentageOfCreativeTime + '%',
                width: '138px',
                align: 'right',
            },
            {
                field: '',
                header: t('payrollEntry.overTime'),
                body: (rowData) => this.overTimeWeekDayTimeTemplate(rowData),
            },
            {
                field: '',
                header: t('global.holidays'),
                body: (rowData) => this.leaveRequestsTemplate(rowData),
            },
            {
                field: 'summedHours',
                header: t('payrollEntry.summedHours'),
                body: (rowData) => this.summedHoursTemplate(rowData),
                width: '150px',
                align: 'center',
            },
        ];
    }

    summedHoursTemplate = (rowData) => {
        const summedMinutes = rowData.summedMinutes;
        const nominalMinutes = rowData.nominalHours * 60;
        const backgroundColor = summedMinutes - nominalMinutes === 0 ? '#7AF697' : '#F67A7A';
        return (
            <Chip
                style={{backgroundColor: backgroundColor, color: 'black'}}
                label={`${NumberUtils.formatTimeIfPossible(summedMinutes)}`}
            />
        );
    };

    leaveRequestsTemplate = (rowData) => {
        const leaveRequests = rowData.leaveRequests;
        const divs = Object.keys(leaveRequests).map((leaveType) => {
            const days = leaveRequests[leaveType].days;
            const result = `${leaveType}: ${days} dni`;
            return <div key={leaveType}>{result}</div>;
        });
        if (divs.length === 0) {
            return <div> Brak </div>;
        }
        return <div>{divs}</div>;
    };

    formatTimeAppovedAndTotal = (rowData) => {
        const approvedTime = rowData.approvedTime;
        const time = rowData.time;
        return NumberUtils.formatTimeIfPossible(time) + '/' + NumberUtils.formatTimeIfPossible(approvedTime);
    };

    overTimeWeekDayTimeTemplate = (rowData) => {
        const weekDayTime = rowData?.overTime?.weekDayTime <= 0 ? 0 : NumberUtils.formatTimeIfPossible(rowData?.overTime?.weekDayTime);
        const saturdayTime = rowData?.overTime?.saturdayTime <= 0 ? 0 : NumberUtils.formatTimeIfPossible(rowData?.overTime?.saturdayTime);
        const sundayTime = rowData?.overTime?.sundayTime <= 0 ? 0 : NumberUtils.formatTimeIfPossible(rowData?.overTime?.sundayTime);
        return (
            <div>
                <div>Zwykłe: {weekDayTime}</div>
                <div>Soboty: {saturdayTime}</div>
                <div>Niedziele: {sundayTime}</div>
            </div>
        );
    };

    formatTime(field, rowData) {
        const time = rowData[field];
        return NumberUtils.formatTimeIfPossible(time);
    }
    prepareHeaderItems() {
        return [
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.list || this.state.list.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }

    renderPrintButton() {
        return (
            <PrintButtonComponent
                key={`print-button-pay-report`}
                reportFileNameBase={t('payrollEntry.listName')}
                xml={false}
                pdf={false}
                csv={false}
                ods={false}
                xlsx={false}
                globalFormat='xlsx'
                noMenuFlag={true}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.list.length > 0}
            />
        );
    }

    generateReport(format) {
        const criteria = this.state.criteria;
        switch (format) {
            case 'xlsx':
                return this.service.exportList(criteria);
            default:
                return Promise.reject('Nieznany format');
        }
    }

    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW'});
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    categoriesTemplate(rowData) {
        if (rowData?.categories) {
            return rowData.categories.map((c) => {
                return <Chip style={{backgroundColor: c?.color?.value, color: 'black'}} label={c.name} />;
            });
        } else {
            return '';
        }
    }

    render() {
        return (
            <div className='container-fluid payrollentry-list'>
                <BreadcrumbsItem to='/payroll-entry'>{'Wsad do listy płac'}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

PayrollEntryListContainer.defaultProps = {
    detailUrl: '/#/payrollEntry/details',
    newUrl: '/#/payrollEntry/create',
    lazy: true,
};

PayrollEntryListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(PayrollEntryListContainer);
